import '../app.es6';
import angular from 'angular';

class BeforeAction {
  /* @ngInject */
  constructor ($rootScope) {
    this.$rootScope = $rootScope;

    BeforeAction.$inject = ['$rootScope'];
  }

  register (action) {
    this.$rootScope.$on('$routeChangeStart', (event, next, current) => {
      action.execute(event, next, current);
    });
  }
}

angular.module('myApp').service('BeforeAction', BeforeAction);



// WEBPACK FOOTER //
// ./app/services/before-action.es6